module.exports = __webpack_public_path__ + "static/media/SEA.f5ce706f.jpeg";